// Third-party imports
import $ from 'jquery';

// Module name
export const MODULE_NAME = 'field';

export let global_vars = {};

export function initialize() {
    $('.field-input').on('change, keyup', event => {
        let target = $(event.target);
        let addons = target.closest('.field-group').find('.field-addon');
        if (target.val()) {
            addons.addClass('field--activeAddon');
        } else {
            addons.removeClass('field--activeAddon');
        }
    });
}
